import React from 'react';

const FormalDbaQuestion = ({ data, setData }) => (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
        <h2 className="text-base font-bold text-[#0a1445] sm:text-lg">
            Will this opportunity be a formal DBA?
            <span className="text-red-600"> *</span>
        </h2>

        <div className="mt-4 grid grid-cols-2 gap-3">
            {['Yes', 'No'].map(option => {
                const selected = data.isDBA === option;
                return (
                    <button key={option} type="button" onClick={() => setData({ ...data, isDBA: option })} className={`h-11 rounded-xl border text-sm font-semibold transition-all ${selected ? 'border-[#fb6635] bg-orange-50 text-[#211b4f] ring-1 ring-[#fb6635]' : 'border-slate-200 text-slate-600 hover:border-orange-200'}`}>
                        {option}
                    </button>
                );
            })}
        </div>
    </section>
);

export default FormalDbaQuestion;
